import { render } from "./Dropdown.vue?vue&type=template&id=22b08fce"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=22b08fce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__